"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactGoogleTagManager = _interopRequireDefault(require("react-google-tag-manager"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class GoogleTagManager extends _react.Component {
  componentDidMount() {
    const scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';
    const gtmAdded = document.getElementById('gtmAdded');

    if (!gtmAdded && document) {
      const script = document.createElement('script');
      const gtmScriptNode = document.getElementById(scriptId);
      let scriptText;

      if (gtmScriptNode) {
        const elem = document.createElement('div');
        elem.setAttribute('id', 'gtmAdded');
        document.body.appendChild(elem);
        scriptText = document.createTextNode(gtmScriptNode.textContent);
        script.appendChild(scriptText);
        document.head.appendChild(script);
      }
    }
  }

  render() {
    const gtm = (0, _reactGoogleTagManager.default)({
      id: this.props.gtmId,
      dataLayerName: this.props.dataLayerName || 'dataLayer',
      additionalEvents: this.props.additionalEvents || {},
      previewVariables: this.props.previewVariables || false
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
      children: [gtm.noScriptAsReact(), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: this.props.scriptId || 'react-google-tag-manager-gtm',
        children: gtm.scriptAsReact()
      })]
    });
  }

}

var _default = GoogleTagManager;
exports.default = _default;

//# sourceMappingURL=GoogleTagManager.js.map